import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";

export const AlertMessage = ({ message, type }) => {
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={8000} onClose={handleClose} /* sx={{ top: { xs: 90, sm: 0 } }} */>
        <Alert onClose={handleClose} severity={type} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>

      {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
<Alert
  onClose={handleClose}
  severity="success"
  variant="filled"
  sx={{ width: '100%' }}
>
  This is a success Alert inside a Snackbar!
</Alert>
</Snackbar> */}
    </>
  );
};
